export default {
    user: {
        login: "/api/login", // 登录
        register: "/api/registerOld",  // 注册
        registerSms: "/api/registerCheckCode/get",//注册获取手机验证码
        changePwd: "/api/changePwd",  // 忘记密码保存密码
        findPwdSms: "/api/findPwd/getCheckCode",  // 忘记密码获取手机验证码
        checkToken: "/api/user/checkToken", // token校验
        logOut:"/api/user/logOut"//退出
    },
    getOrgList: '/api/getOrgList', //注册获取分公司列表
    userCenter: {
        getTheMask:"/api/user/userCenter/getTheMask",//领取口罩
        sendCode: "/api/user/userCenter/mobileSms", //发送验证码
        updateMobile: "/api/user/userCenter/updMobile", //更改手机号
        updatePass: "/api/user/userCenter/updPassword", //修改密码
        findPwd: "/api/findPwd/getCheckCode",  // 忘记密码
        collectGoods: "/api/user/userCenter/selColletGoodsListPage",//商品收藏
        favoriteDel: "/api/user/userCenter/favoriteDel",//删除收藏
        areaList: '/api/user/userCenter/getAreaList',//省市区
        getUserInfo: '/api/user/getUserInfo', //每个用户每种订单类型数量
        selMyCommentListPage: '/api/user/userCenter/selMyCommentListPage', //我的评价
        selAddrList: '/api/user/userCenter/selAddrList',//查询收货地址
        addressSave: '/api/user/userCenter/addressSave',//save or update收货地址
        delAddr: '/api/user/userCenter/delAddr',//delete
        selTrackListPage: '/api/user/userCenter/selTrackListPage',//历史浏览
        selCounselListPage: '/api/user/userCenter/selCounselListPage',//站内咨询
        selForMyapprovalWorkflowPage: '/api/user/userCenter/selForMyapprovalWorkflowPage',//待我审核搜索
        selAuditedListPage: '/api/user/userCenter/selAuditedListPage',//已审核
        selAuditedDetailInfo: 'api/user/userCenter/selAuditedDetailInfo',//审核详情
        enginWorkFlow:'/api/user/jmWorkflow/enginWorkFlow_edit',//修改审批的详情
        rejectEngineDeal:'/api/user/flowEngine/rejectEngineDeal',//修改审批通过
        saveWorkflow:'/api/user/jmWorkflow/saveWorkflow',//修改审批保存
        saveUserInfo: '/api/user/userCenter/saveUserInfo',//保存用户信息
        consult_reply_save: '/api/user/userCenter/consult_reply_save',//咨询回复
        consult_del: '/api/user/userCenter/consult_del',//删除咨询
        milkImportConfirmList: '/api/user/userCenter/milkImportConfirmList',//查询月账单
        milkImportConfirm: '/api/user/userCenter/milkImportConfirm',//月度对账单详情
        getMaxMoneyPay: '/api/user/milkImportAudit/getMaxMoneyPay',//获取最大支付金额
        milkPayunderLinePay: '/api/user/milkImportAudit/milkPayunderLinePay',//线下支付提交
        onlinePay: '/api/user/milkImportAudit/onlinePay',//线上银联支付
        milkImComfirmDeal: '/api/user/userCenter/milkImComfirmDeal',//处理对账单确认/驳回
        selGroup:'/api/user/userCenter/selMessageListGroupByMesType',//消息中心
        selConsult:'/api/user/userCenter/selMessageListGroupByConsult',//咨询消息中心
        selMessageList: '/api/user/userCenter/selMessageList',//站内消息查询站内消息
        lookMessages: '/api/user/userCenter/lookMessages',//站内消息查看按钮
        delMessages: '/api/user/userCenter/delMessages',//站内消息删除按钮
        messageReply: '/api/user/userCenter/messageReply',//站内消息回复
        turnTableGameConsumIntegral: '/api/consumerIntegral/turnTableGameConsumIntegral',//大转盘消耗积分
        turnTableGameFree: '/api/consumerIntegral/turnTableGameFree',//判断是否可抽奖(无需积分)
        eggGameConsumIntegral: '/api/consumerIntegral/eggGameConsumIntegral',//砸金蛋消耗积分
        turnTableGameGetIntegral: '/api/slIntegral/turnTableGameGetIntegral',//大转盘中将积分
        turnTableGameGetIntegralFree: '/api/slIntegral/turnTableGameGetIntegralFree',//获取优惠券和积分
        eggGameGetIntegral: '/api/slIntegral/eggGameGetIntegral',//砸金蛋中将积分
        getGameConsumIntegral: '/api/slIntegral/getGameConsumIntegral',//小游戏所需积分
        getConfigDocInfoEnable:'/api/user/userCenter/getConfigDocInfoEnable',//我的积分里的配置项
        getDictionaryByCode: 'jmDictionary/getDictionaryByCode',//审批延迟原因
        getOuByCus: '/api/user/jmWorkflow/getOuByCus',//erp信息-获取业务实体
        getOrgByOuId: '/api/user/jmWorkflow/getOrgByOuId',//erp信息-ERP库存组织
        getShimpmenthodEc: '/api/user/jmWorkflow/getShimpmenthodEc',//erp信息-ERP承运方式
        getCarriersEc: '/api/user/jmWorkflow/getCarriersEc',//erp信息-以承运方式获取承运人
        getOrderTypeListByOuId: '/api/user/jmWorkflow/getOrderTypeListByOuId',//erp信息 获取订单类型
        getPriceListByOuIdAndOrderId: '/api/user/jmWorkflow/getPriceListByOuIdAndOrderId',//erp信息-获取价目表
        getGoodsPriceByPriceListIdAndGoodsId: '/api/user/jmWorkflow/getGoodsPriceByPriceListIdAndGoodsId',//erp信息-获取价目表价格
        getPaymentTerm: '/api/user/jmWorkflow/getPaymentTerm',//erp信息-ERP付款条件
        getDriver: '/jmDriver/getDriver',//根据车牌号获取司机信息
        changeTransport: '/api/user/jmWorkflow/changeTransport',//变更邮寄
        changeToBatchOut: '/api/user/jmWorkflow/changeToBatchOut',//变更分批出库
        setBatchOutComplete: '/api/wrokflow/delivery/setBatchOutComplete',//已全部出库
        orderGoodsGiveSave: '/api/wrokflow/delivery/orderGoodsGiveSave',//设置商品赠送数
        saveShip: '/api/user/jmWorkflow/saveShip',//保存发运数量
        changeWorkFlowType: '/api/user/jmWorkflow/changeWorkFlowType',//变更为非入库原料流程
        deliveryGoodsorderCreateSave: 'api/wrokflow/delivery/deliveryGoodsorderCreateSave',//创建出库单
        outboundSingleQueryPage: '/api/user/userCenter/outboundSingleQueryPage',//出库单列表
        deliveryDetail: '/api/user/userCenter/delivery_goodsorder_manage',//出库单详情
        delivery_goodsorder_view: '/api/user/userCenter/delivery_goodsorder_view',//退款出库单详情
        queryAreaAndShop: 'org/queryAreaAndShop',//查询片区和奶牛超市
        bAdminFlowUpdateUserInfo: '/api/user/bAdminflowUpdateUserInfo',//分公司管理员更新保存用户信息
        bmUpdateUserInfo: '/api/user/bmUpdateUserInfo',
        deliveryGoodsorderDeductSave: '/api/wrokflow/delivery/deliveryGoodsorderDeductSave',//确认扣款
        deliveryGoodsorderSendGoodsSave: '/api/wrokflow/delivery/deliveryGoodsorderSendGoodsSave',//发货
        deliveryGoodsorderConfirmSave: '/api/wrokflow/delivery/deliveryGoodsorderConfirmSave',//确认出库
        deliveryGoodsorderRmAuditSave: '/api/wrokflow/delivery/deliveryGoodsorderRmAuditSave',//库管审核通过（出库单）
        deliveryGoodsorderCancelSave: '/api/wrokflow/delivery/deliveryGoodsorderCancelSave',//取消出库
        deliverGoodsQueryPage: '/api/user/userCenter/deliverGoodsQueryPage',//发货查询
        orderReturnApplyCheck: '/api/user/order/orderReturnApplyCheck',//订单可退货校验
        getReturnReason: '/api/user/jmWorkflow/getReturnReason',//退货原因
        integralLogPageList: '/api/user/recommandBuyer/integralLogPageList',//我的积分明细
        getConfigValue: '/api/user/recommandBuyer/getConfigValue/TARGET_MEMBER_CONFIG',//获取积分配置明细
        getTargetMoney: '/api/slIntegral/getTargetMoney',//获取会员目标金额
        getQrCode: '/api/user/userCenter/getQrCode',//我的推荐二维码
        delTrack: '/api/user/userCenter/delTrack',//删除历史
        getConfigDocEnable: '/api/user/userCenter/slIntegral/getConfigDocEnable',//签到配置
        bmReplaceOrder: '/api/user/userCenter/bmReplaceOrder',//设置代理
        cancelcancelReplaceOrder: '/api/user/userCenter/cancelcancelReplaceOrder',//取消代理
        getBusinessMyUser: '/api/user/userCenter/getBusinessMyUser',//我的会员列表
        deliveryGoodsOrderSaveReceivedCount: '/api/wrokflow/delivery/deliveryGoodsOrderSaveReceivedCount',//填写到货量
        confirmDeliverySaveSense: '/api/user/order/confirmDeliverySaveSense',//确认出库单
        bindAccountList:'/api/user/userCenter/bindAccountList',//
        bindAccountSave:'/api/user/userCenter/bindAccountSave',//
        bindAccountDel:'/api/user/userCenter/bindAccountDel',//
        placeOrderByBindAccount:'/api/user/userCenter/placeOrderByBindAccount',//
        getConfigDoc:'/api/user/userCenter/getConfigDocEnable'//
    },
    order: {
        orderList: '/api/user/order/orderQuery', //查询订单
        orderDetail: '/api/user/order/orderDetail', //查询订单详情
        orderIsShouHuo: '/api/user/order/confirmOrderView', //确认收货获取商品信息
        orderShouHuo: '/api/user/order/confirmOrderSave', //确认收货
        receiveCheck: '/api/user/order/receiveCheck', //查看确认单
        rebuy: '/api/user/order/rebuy', //再次购买
        outOrder: '/api/user/order/deliveryGoodsorderBuyerView', //查看出库单
        cancelOrder: '/api/user/order/cancelOrder', //取消订单
        orderReturnApplySave: '/api/user/order/orderReturnApplySave', //申请退货
        getDelayedReceiptDay: '/api/user/order/getDelayedReceiptDay', //获取延迟收货天数
        delayedReceipt: '/api/user/order/delayedReceipt', //延迟收货
        getEvaluateOrder: '/api/user/order/getEvaluateOrder', //获取评价订单
        getEvaluateType: '/api/user/order/getEvaluateType', //获取评价订单类型
        evaluateOrderSave: '/api/user/order/evaluateOrderSave', //提交评价订单
        goodsConsult: '/jmGoods/goodsConsult', //商品咨询列表
        goodsConsultSave: 'jmGoods/goodsConsultSave',//商品咨询
        confirmDeliverySave: '/api/user/order/confirmDeliverySave',//分批发运出库确认收货
    },
    cart: {
        list: '/api/user/cart/goodsCartView',//购物车列表
        add: '/api/user/cart/addGoodsCart',//加入购物车
        remove: '/api/user/cart/removeCartGoods',//删除购物车
        changeCount: '/api/user/cart/goodsCountAdjust',//购物车数量调整
        checkOrder: '/api/user/cart/checkOrder',//确认订单
        submitOrder: '/api/user/cart/submitOrder',//订单提交
        addressChangeFreight: '/api/user/cart/addressChangeFreight',//获取运费
        addressFreight:'/api/user/cart/addressFreight',//修改审批时
        getConfig:'/api/getConfig'//预售商品的发货天数
    },
    stock: {
        milkshop_stock_view: '/api/user/jmWorkflow/milkshop_stock_view',//奶牛查看库存
        goods_stock_view: '/api/user/jmWorkflow/goods_stock_view',//成品查看库存
        erp_orderinfo_view: '/api/user/jmWorkflow/erp_orderinfo_view',//同步ERP状态
        changeDealyDeal: '/api/user/jmWorkflow/workFlow/changeDealyDeal',//审批延迟提交
        savedeal: '/api/user/jmWorkflow/deal',//审批通过
        dealEngine: '/api/user/flowEngine/dealEngine',//新审批通过
        saveDriver:'/api/user/jmWorkflow/saveDriver',//保存司机信息
    },
    milk: {
        loadImportDetail: '/api/user/milkImportAudit/milkImAuditDetailList',//获取月结账单导入明细
        memberConfirmList: '/api/user/milkImportAudit/milkImportConfirmPage',//用户确认数据
        importSummary: '/api/user/milkImportAudit/selectImportSum',//月结账单汇总数据
        onlinePay:'/api/user/milkImportAudit/onlinePay',//月结账单的银联支付校验保存记录
        milkWorkflowDetail: '/api/user/milkImportAudit/milkImAuditDetail',//用户确认列表
        milkReturnMoneyDetail: '/api/user/milkImportAudit/refundInfo',//还款明细
        closeMilk: '/api/user/milkImportAudit/closeMilk',//还款明细
        offlinePay: '/api/user/milkImportAudit/closeMilk',//线下支付审批内容获取
    },
    getGoodsPrice:'/api/user/cart/getGoodsPrice',//根据支付方式，获取商品价格
    goodsList: '/jmGoods/selectGoodsByGoodsClass', //根据分类查询商品
    goodsListInit: '/jmGoods/goodsFiltrateInit',//根据分类查询商品参数初始化
    goodsClass: '/jmGoodsClass/selGoodsClassAll',//分类查询
    goods: '/jmGoods/',//商品详情
    goodsEvaluation: '/jmGoods/goodsEvaluation/',//商品详情
    collect: '/api/user/collect/add_favorite',//添加收藏
    search: '/jmGoods/search',//头部检索
    getIndexInfo: '/index/getIndexInfo',//首页通知列表
    getIndexArticle: '/index/getIndexArticle',//启动页
    articleItem: '/article/articleItem',//首页通知文章
    indexInfo: '/index/getIndexInfo',//首页信息
    indexActive: '/index/getIndexArticle',//启动页
    advertInvoke: '/jmAdvPos/advertInvoke',//广告
    pay: {
        onLinePaymentCodes: '/pay/getOnLinePaymentCodes',//线上支付渠道查询
        unionPay: '/pay/genericUnionPay',//银联支付
        order: '/api/user/cart/orderPay',//线下支付
    },
    integral: {
        category: '/api/user/integralShop/integralGoodsCategory',//商品分类
        goodsList: '/api/user/integralShop/selectIntegralGoodsPage',//商品查询
        goodsDetail: '/api/user/integralShop/getIntegralGoods',//商品详情
        adjustCount: '/api/user/integralShop/integralAdjustCount',//增减商品数量
        createOrder: '/api/user/integralShop/createOrder',//创建订单
        orderList: '/api/user/integralShop/myIntegralOrderPage',//积分订单列表
        orderDetail: '/api/user/integralShop/selIntegralOrder',//查看订单
        confirmOrder: '/api/user/integralShop/confirmAOG',//确认收货
        auditOrderList: '/api/user/integralShop/selAuditIntegralOrderListPage',//审核列表
        auditOrder: '/api/user/integralShop/auditIntegralOrder',//审核
        orderConsumIntegral: '/api/consumerIntegral/placeOrderConsumIntegral',//下单消耗积分
        top3: '/api/user/integralShop/getIndexTop3',//积分商城首页top3
        signIn: '/api/user/signIn', //签到
        share: '/api/slIntegral/shareGetIntegral',//分享获取积分
        forward: '/api/slIntegral/forwardGetIntegral',//转发获取积分
        getIntegralTopBanner:'/index/getIntegralTopBanner',//积分商城轮播图
    },
    upload: {
        userInfoUpload: "/workFlow/userImgUpload.htm"
    },
    plan:{
        lookShipmentPlan:'/api/user/jmWorkflow/lookShipmentPlan',//查看发运计划
        saveShipmentPlan:'/api/user/jmWorkflow/saveShipmentPlan',//保存发运计划
    },
    wx: {
        appId: "wxa9dda315a8734825",
        appSecret: '93c9493cf574bbff7d5778f75b829f52',
        login: '/api/openIdLogin',//微信登录
        saveWx: '/api/user/userCenter/saveWx',//保存微信绑定
        delWx: '/api/user/userCenter/delWx',//接触绑定
        sendBindSms: 'api/bindWxOpenIdmobileSms',//发送绑定短信
        bindUser: '/api/bindWxOpenId',//保存账号绑定
    },
    getVersion:'/index/getVersion',
    getUserSysMilkDiscount:'/api/user/userCenter/getUserSysMilkDiscount',//消费任务
    integralStatistic:'/api/user/integralStatistic',//用户积分统计
    saveGoodsInfo:'/api/user/flowEngine/saveGoodsInfo',//保存商品单价，执行合同信息，
    integralStatisticBiz:'/api/user/integralStatisticBiz',//业务员积分统计,
    integralStatEngineer:'api/user/integralStatEngineer',//电商工程师 积分统计
    articleByMark:'/article/articleByMark',//如何赚积分
    verify:'/api/verifyController/verify',//专家获取的验证码
    createPurOrder:'/api/user/jmWorkflow/createPurOrder',//审批生成采购订单
    createChuOrder:'/api/wrokflow/delivery/createPurOrder',//出库单里的生成采购订单
    buyerBmToMember:'/api/user/userCenter/buyerBmToMember'//业务员看到的消费记录
}
